<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-select
            v-model="formData.meter_id"
            :items="meters"
            label="العداد"
            item-title="name"
            item-text="code"
            item-value="id"
          >
          </v-select>
          <v-text-field
            type="number"
            v-model="formData.initial_reading"
            :rules="initial_readingRules"
            label="القراءة الاولية"
          ></v-text-field>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>
        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import repo from "@/store/repo.js";
export default {
  props: ["customer", "meters", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        customer_id: "",
        meter_id: "",
        initial_reading: 0,
      },
      initila_readingRules: [(v) => (v && v >= 0) || "exceeded"],
    };
  },
  computed: {},
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.formData.customer_id = this.customer.id;
        await repo.customers.updateMeter(this.formData);

        this.$emit("closed");
        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        console.log(value);
      }
    },
  },
};
</script>
